<div>	
	<div *ngIf="featType">
		type: {{featType}}
	</div>
	<div [ngSwitch]="displayObj.displayType">
		<!-- Point -->
		<div *ngSwitchCase="'string'">
			<div class="coords-group coord-string" (mouseover)="onMouseoverCoord(displayObj.coords)" (mouseout)="onMouseoutCoord()">{{displayObj.coords}}</div>
		</div>
		<!-- Line / Polygon-->
		<div *ngSwitchCase="'array'">
			<div class="coords-group">
				<div class="first-line">
					<i class="glyphicons"
						[ngClass]="{'glyphicons-minus': isExpand, 'glyphicons-plus': !isExpand}"
						(click)="isExpand=!isExpand"
					></i>
					<div>[</div>
				</div>
			</div>
			<ng-container *ngIf="isExpand">
				<div *ngFor="let item of displayObj.coords; let idx = index;" class="coords-group">
					<app-feature-coordinates-display [coordinates]="item"></app-feature-coordinates-display>
					<span *ngIf="idx < displayObj.coords.length - 1">,</span>
				</div>
			</ng-container>
			<div>]</div> 
		</div>
	</div>
</div>